export const PRICE_ID_CONTAINER = 'priceIdContainer';
